angular.module('SpidApp')

.directive('quantityOnly', function(){
	return {
		require: '?ngModel',
        restrict: 'A',
        link: function(scope, element, attrs, ngModelCtrl) {
    		if(!ngModelCtrl) {
    			return; 
    		}

    		ngModelCtrl.$parsers.push(function(val) {
    			if (angular.isUndefined(val)) {
    				val = '';
    			}
            
    			var clean = ''+val.replace(/[^0-9]/g, '');

    			if (val !== clean) {
    				ngModelCtrl.$setViewValue(clean);
    				ngModelCtrl.$render();
    			}
    			return clean;
    		});

    		element.bind('keypress', function(event) {
    			if(event.keyCode === 32) {
    				event.preventDefault();
    			}
    		});
        }
	};
})

.directive('spidFormInputQuantity', ['BASE_PUBLIC_URL', '$timeout', function(BASE_PUBLIC_URL, $timeout){
    return { 
    	priority: 0,
    	restrict: 'AE',
    	scope: {
    		spidname   : '@',
    		spidmodel  : '=',
    		spidclass  : '=',
    		spidchange : '&'
    	},
    	templateUrl: BASE_PUBLIC_URL + '/views/partials/my-directive-quantity-only.html',
    	compile: function compile(elem, attr) {
    		var html = elem.find('input');
    		html.attr('required', attr.required);
    		html.attr('pattern', attr.pattern);
    	},
    	controller: function($scope) {
    		$scope.incrementQuantity = function () {
    			if (!$scope.spidmodel) {
    				$scope.spidmodel = 0;
    			}
    			$scope.spidmodel = +$scope.spidmodel + 1;
    			$scope.valueChange();
    		}

    		$scope.decrementQuantity = function () {
    			if ($scope.spidmodel && $scope.spidmodel !== 0) {
    				$scope.spidmodel = +$scope.spidmodel - 1;
    				$scope.valueChange();
    			}
    		}
    		
    		$scope.valueChange = function() {
    			$timeout(function() {
    				$scope.spidchange();
    			},0)
    		}
    	}
    };  
}]);